import { render, staticRenderFns } from "./ImageUploadForm.vue?vue&type=template&id=0d0d6a7c&scoped=true"
import script from "./ImageUploadForm.vue?vue&type=script&lang=ts"
export * from "./ImageUploadForm.vue?vue&type=script&lang=ts"
import style0 from "./ImageUploadForm.vue?vue&type=style&index=0&id=0d0d6a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0d6a7c",
  null
  
)

export default component.exports